import { render, staticRenderFns } from "./AdminReclassify.vue?vue&type=template&id=02b998a2&"
import script from "./AdminReclassify.vue?vue&type=script&lang=js&"
export * from "./AdminReclassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports